/**
 * Header Megamenu Tabs
 * Handles tab switching for the header megamenu product display (Desktop)
 * and mobile drawer megamenu tabs
 */

class HeaderMegamenuTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.header__megamenu-tab');
    this.panels = container.querySelectorAll('.header__megamenu-panel');

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      // Desktop: Hover to switch
      tab.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          this.switchTab(index);
        }
      });

      // Click to navigate (allow default behavior)
      tab.addEventListener('click', () => {
        this.switchTab(index);
        // Navigation happens via href - no preventDefault
      });
    });
  }

  switchTab(index) {
    // Remove active class from all tabs and panels
    this.tabs.forEach(tab => tab.classList.remove('is-active'));
    this.panels.forEach(panel => panel.classList.remove('is-active'));

    // Add active class to selected tab and panel
    if (this.tabs[index]) {
      this.tabs[index].classList.add('is-active');
    }
    if (this.panels[index]) {
      this.panels[index].classList.add('is-active');
    }
  }
}

/**
 * Mobile Drawer Megamenu Tabs
 * Handles tab switching for mobile navigation drawer megamenu
 */
class MobileDrawerMegamenuTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.mobile-megamenu-tab');
    this.panels = container.querySelectorAll('.mobile-megamenu-panel');

    if (this.tabs.length === 0 || this.panels.length === 0) return;

    this.init();
  }

  init() {
    this.tabs.forEach((tab, index) => {
      // Click to switch tabs
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(index);
      });
    });
  }

  switchTab(index) {
    // Remove active class from all tabs and panels
    this.tabs.forEach(tab => tab.classList.remove('is-active'));
    this.panels.forEach(panel => panel.classList.remove('is-active'));

    // Add active class to selected tab and panel
    if (this.tabs[index]) {
      this.tabs[index].classList.add('is-active');
    }
    if (this.panels[index]) {
      this.panels[index].classList.add('is-active');
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  // Desktop megamenu tabs
  const megamenuContainers = document.querySelectorAll('.header__nav-dropdown-inner--products');
  megamenuContainers.forEach(container => {
    new HeaderMegamenuTabs(container);
  });

  // Mobile drawer megamenu tabs
  const mobileDrawerContainers = document.querySelectorAll('.mobile-megamenu-wrapper');
  mobileDrawerContainers.forEach(container => {
    new MobileDrawerMegamenuTabs(container);
  });
});
